import React from 'react';

const Footer = () => {
  return (
    <div className='flex justify-center w-full lg:mx-auto py-6'>
      <span className='text-xs text-slate-400 uppercase'>&copy; 2025 <a href='https://linkedin.com/in/mkrmsv' target='_blank' className='hover:text-blue-600'>Makarii Mysiv</a> &bull; All rights reserved</span>
    </div>
  );
};

export default Footer;